export const timeFormat = 'hh:mm A';
